// extracted by mini-css-extract-plugin
export default {"Logo":"AppDestopLogo_Logo__ySXLW"};